import React, { useState, useEffect, useRef, useMemo } from "react";
import useDidMountEffect from "../../customHooks/useDidMountEffect";
import { useTranslation } from "react-i18next";
import TableExpanded from "../../components/Table/TableExpanded";
import SepTable from "../../components/SepTable/SepTable";
import ExpandedChip from "../../components/ExpandedChip/ExpandedChip";
import HeDatePicker from "../../components/HeDatePicker/HeDatePicker";
import RadioButtons from "../../components/RadioButtons/RadioButtons";
import ExcelExportButton from "../../components/ExcelExportButton/ExcelExportButton";
import { GetDepositData } from "../../services/GetDepositData";
import DepositData from "../../entities/DepositData";
import ErrorRender from "../../components/ErrorRender/ErrorRender";
import {
    filterAscribedDepositsByDate,
    filterDepositsByDate,
    filterTransactionsByDate,
} from "../../utils/helpers/filterByDate";
import { useDispatch, useSelector } from "react-redux";
import {
    resetLettersReports,
    setLatestEndDate,
    setLatestRadioValue,
    setLatestStartDate,
} from "../../state/actions/LettersReportsActions";
import DetailsNotFound from "../../components/DetailsNotFound/DetailsNotFound";
import { GetCollectionTransactions } from "../../services/GetCollectionTransactions";
import TransactionsData from "../../entities/TransactionsData";
import CircleLoading from "../../components/CircleLoading/CircleLoading";
import UserFund from "../../entities/UserFund";
import filterIcon from "../../assets/images/filter-icon.png";
import { setModalChild, setModalState } from "../../state/actions/modalAction";
import FilterDepositsPopup from "../../components/FilterDepositsPopup/FilterDepositsPopup";
import { getFromDateValue } from "../../utils/helpers/dateFormatter";

import "./Deposits.scss";
import { getFunds } from "../../services/Deposit.service";
import useWindowDimensions from "../../customHooks/useWindowDimensions";
import { screenSzie } from "../../utils/main";
import { setMifneFunds } from "../../state/actions/UserActions";
import { getFundCode } from "../../utils/helpers/getFundCertificateNumber";

// Used for change the mode of component, if active label render is deposits - render deposits data.
// else - render transactions data.
const DEPOSITS_LABEL = "DEPOSITS";
const TRANSACTIONS_LABEL = "TRANSACTIONS";

const Deposits = () => {
    const { t, i18n } = useTranslation("common");
    const { userId, userFunds } = useSelector((state: any) => state.UserReducer);
    const { activeFund } = useSelector((state: any) => state.DashboardReducer);
    const [funds, setFunds] = React.useState<any>([]);


    const getFundLabels = () => {
        return userFunds
            ?.filter((fund: UserFund) => fund.isAmit)
            .map((fund: UserFund) => `${fund.fundLabel}`);
    };

    const divRef = useRef<any>(null);
    const [radioValue, setRadioValue] = useState<string>(
        t("LettersReports.radioValue1")
    );
    const [startDateValue, setStartDateValue] = useState<Date | number | string>(
        getFromDateValue()
    );
    const [endDateValue, setEndDateValue] = useState<Date | number | string>(
        new Date()
    );
    const [currentChip, setCurrentChip] = useState<number>(1);
    const [latestChip, setLatestChip] = useState<number>(0);
    const [currentFirstLabel, setFirstLabel] = useState<string>('');
    //
    // Object.keys(activeFund).length
    //     ? activeFund.fundLabel
    //     : `${getFundLabels()[0]}`
    const [currentSecondLabel, setSecondLabel] = useState<string>(
        t("deposits.secondChipLabel1")
    );
    const [latestFirstLabel, setLatestFirstLabel] = useState<string>("");
    const [latestSecondLabel, setLatestSecondLabel] = useState<string>("");

    const [userDepositData, setDepositData] = useState<DepositData[]>([]);
    const [userTransactionsData, setTransactionsData] = useState<TransactionsData[]>([]);
    const [renderLabel, setRenderLabel] = useState<string>(DEPOSITS_LABEL);
    const [latestRenderLabel, setLatestRenderLabel] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(true);
    const [dateError, setDateError] = useState<boolean>(false);
    const [showFilterBtn, setShowFilterBtn] = useState<boolean>(true);
    const dispatch = useDispatch();
    const timer = useRef<any>(null);

  

    const { width } = useWindowDimensions();
    const isMobile = (width < screenSzie.tabletxl);

    const getFundsApi = async () => {
        const response: any = await getFunds();
        if (response.status === 200 && response.data.errorCode === 0) {
            setFunds(response.data.funds)
            const setUserFunds = await userFunds.filter((item:any)=> {return Number(item.fundCode) == sessionStorage.fundCode  }) 
            setFirstLabel(setUserFunds[0].fundLabel !== null && sessionStorage.fundCode ? `${setUserFunds[0].fundLabel}` : response.data.funds[0].fundNameHeb);
        }

    }


    useEffect(() => {
        document.title = "amitim " + t("deposits.title");
    }, []);


    React.useEffect(() => {
        getFundsApi();
    }, [])

    const handleChipClick = (chipIndex: number) => {

        if (isMobile && chipIndex === 3){
          setShowFilterBtn(false)
        }
        if (isMobile && currentChip === 3 && chipIndex === 3){
          setShowFilterBtn(true)
        }
        if (chipIndex === 3) {
          
            // The user click is on afterSepDeposits chip
            startDateValue !== "01/01/2018" && setStartDateValue("01/01/2018");
            endDateValue?.toLocaleString() !== new Date().toLocaleString() &&
                setEndDateValue("08/31/2018");
            radioValue !== t("LettersReports.radioValue2") &&
                setRadioValue(t("LettersReports.radioValue2"));
            setRenderLabel(TRANSACTIONS_LABEL);
        }

        if (currentChip === 3 && chipIndex === 3) {
            // The active chip is afterSepDeposits and the user click
            setCurrentChip(1);
            startDateValue !== getFromDateValue() &&
                setStartDateValue(getFromDateValue());
            endDateValue?.toLocaleString() !== new Date().toLocaleString() &&
                setEndDateValue(new Date());
            radioValue === t("LettersReports.radioValue2") &&
                setRadioValue(t("LettersReports.radioValue1"));
            radioValue === t("LettersReports.radioValue1") &&
                divRef?.current?.childElementCount === 3 &&
                setRadioValue(t("LettersReports.radioValue1"));
            setRenderLabel(DEPOSITS_LABEL);
        } else if (currentChip === 3 && chipIndex !== 3) {
            // If the currentChip is afterSepDeposits, dont do nothing
            return;
        } else {
            setCurrentChip(chipIndex);
        }
    };

    const isActiveChip = (chipIndex: number) => currentChip === chipIndex;

    const datePickerIsDisabled = () =>
        radioValue === t("LettersReports.radioValue1");

        function onlyUnique(value:any, index:number, array:any) {
          return array.indexOf(value) === index;
        }

    const   newSetUserFunds:any =   new Set(userFunds.map((item: any) => { return item?.fundLabel }))
    let labeluserFunds = [t("deposits.firstChipLabel1"), ...newSetUserFunds]

    const SecondChipLabels: string[] = [
        t("deposits.secondChipLabel1"),
        t("deposits.secondChipLabel2"),
        t("deposits.secondChipLabel3"),
    ];

    const validateDatePickerValues = () => {
        // validate date picker values
        if (
            startDateValue &&
            startDateValue !== "" &&
            endDateValue &&
            endDateValue !== "" &&
            new Date(startDateValue) > new Date(endDateValue)
        ) {
            setDateError(true);
            if (currentChip !== 3) {
                setStartDateValue(getFromDateValue());
                setEndDateValue(new Date());
            } else {
                setStartDateValue("01/01/2018");
            }
            if (timer.current) clearTimeout(timer.current);
            timer.current = setTimeout(() => {
                setDateError(false);
            }, 5000);
        }
    };


    const filterTransactions = () => {
        const activeFundCode = getFundCode(userFunds , currentFirstLabel);
        if (radioValue === t("LettersReports.radioValue1")) {
            const endDate: Date | string = new Date().toLocaleDateString();
            let startDate: Date | string = new Date();
            startDate.setMonth(startDate.getMonth() - 12);
            startDate = startDate.toLocaleDateString();
            return filterTransactionsByDate(
                userTransactionsData,
                startDate,
                endDate,
                activeFundCode
            );
        } else {
            return filterTransactionsByDate(
                userTransactionsData,
                startDateValue,
                endDateValue,
                activeFundCode
            );
        }
    };

    const filterDeposits = () => {
        const activeFundCode = getFundCode(userFunds , currentFirstLabel);
        if (radioValue === t("LettersReports.radioValue1")) {
            // filter by last 12 months
            const endDate: Date | string = new Date().toLocaleDateString();
            let startDate: Date | string = new Date();
            startDate.setMonth(startDate.getMonth() - 12);
            startDate = startDate.toLocaleDateString();
            if (currentSecondLabel === SecondChipLabels[0]) {
                // filter by all deposits status and activeFundCode if active.
                return filterDepositsByDate(
                    userDepositData,
                    startDate,
                    endDate,
                    activeFundCode
                );
            } else if (currentSecondLabel === SecondChipLabels[1]) {
                // filter by ascribed deposits and activeFundCode if active.
                return filterAscribedDepositsByDate(
                    userDepositData,
                    startDate,
                    endDate,
                    true,
                    activeFundCode
                );
            } else if (currentSecondLabel === SecondChipLabels[2]) {
                // filter by not ascribed deposits and activeFundCode if active.
                return filterAscribedDepositsByDate(
                    userDepositData,
                    startDate,
                    endDate,
                    false,
                    activeFundCode
                );
            }
        } else {
            // filter by user entered dates
            if (currentSecondLabel === SecondChipLabels[0]) {
                // filter by all deposits status and activeFundCode if active.
                return filterDepositsByDate(
                    userDepositData,
                    startDateValue,
                    endDateValue,
                    activeFundCode
                );
            } else if (currentSecondLabel === SecondChipLabels[1]) {
                // filter by ascribed deposits and activeFundCode if active.
                return filterAscribedDepositsByDate(
                    userDepositData,
                    startDateValue,
                    endDateValue,
                    true,
                    activeFundCode
                );
            } else if (currentSecondLabel === SecondChipLabels[2]) {
                // filter by not ascribed deposits and activeFundCode if active.
                return filterAscribedDepositsByDate(
                    userDepositData,
                    startDateValue,
                    endDateValue,
                    false,
                    activeFundCode
                );
            }
        }
    };

    const trackLastSuccessfulResult = () => {
        if (radioValue === t("LettersReports.radioValue1")) {
            dispatch(setLatestRadioValue(t("LettersReports.radioValue1")));
            setLatestFirstLabel(currentFirstLabel);
            setLatestSecondLabel(currentSecondLabel);
        } else if (radioValue === t("LettersReports.radioValue2")) {
            dispatch(setLatestRadioValue(t("LettersReports.radioValue2")));
            dispatch(setLatestStartDate(startDateValue));
            dispatch(setLatestEndDate(endDateValue));
            setLatestFirstLabel(currentFirstLabel);
            setLatestSecondLabel(currentSecondLabel);
        }

        if (divRef?.current?.childElementCount === 3) {
            setLatestChip(3);
            setLatestRenderLabel(TRANSACTIONS_LABEL);
        } else {
            setLatestChip(1);
            setLatestRenderLabel(DEPOSITS_LABEL);
        }
    };

    useEffect(() => {
        async function init() {
            setLoading(true);
            const depositsData = await GetDepositData();
            const transactionsData = await GetCollectionTransactions();
            setDepositData(depositsData);
            setTransactionsData(transactionsData);
            setLoading(false);
            // Promise.all([
            //   GetDepositData(), // 56418270 55753297
            //   GetCollectionTransactions(),
            // ]).then((results) => {
            //   setDepositData(results[0]);
            //   setTransactionsData(results[1]);
            //   setLoading(false);
            // });
        }

        init();
        return () => {
            dispatch(resetLettersReports());
            if (timer.current) clearTimeout(timer.current);
        };
        // eslint-disable-next-line
    }, []);

    useDidMountEffect(() => {
        validateDatePickerValues();
    }, [startDateValue, endDateValue]);

    useDidMountEffect(() => {
        setRadioValue(t("LettersReports.radioValue1"));
        setCurrentChip(1);
        setSecondLabel(t("deposits.secondChipLabel1"));
    }, [i18n.language]);

    const filteredDeposits = useMemo(
        // Handle dependencies changes, and filter the current array
        // by radio, date's or chip labels values.
        () => {
            if (renderLabel === DEPOSITS_LABEL) {
                if (userDepositData && userDepositData.length) {
                    return filterDeposits();
                }
            } else {
                if (userTransactionsData && userTransactionsData.length) {
                    return filterTransactions();
                }
            }
            return [];
        },
        // eslint-disable-next-line
        [
            renderLabel,
            userDepositData,
            userTransactionsData,
            radioValue,
            startDateValue,
            endDateValue,
            currentFirstLabel,
            currentSecondLabel,
        ]
    );

    useEffect(() => {
        // Track the last successful filter and save data in store
        if (filteredDeposits && filteredDeposits.length) {
            trackLastSuccessfulResult();
        }
        // eslint-disable-next-line
    }, [filteredDeposits || filteredDeposits?.length]);

    const disableExportButton = () => !filteredDeposits?.length; // if length is zero, disable button

    const openMobileFilterPopup = () => {
        dispatch(setModalState(true));
        dispatch(
            setModalChild(
                <FilterDepositsPopup
                    size="m"
                    center={true}
                    radioValue={radioValue}
                    setRadioValue={setRadioValue}
                    startDateValue={startDateValue}
                    setStartDateValue={setStartDateValue}
                    endDateValue={endDateValue}
                    setEndDateValue={setEndDateValue}
                    datePickerIsDisabled={datePickerIsDisabled}
                    SecondChipLabels={SecondChipLabels}
                    currentSecondLabel={currentSecondLabel}
                    setSecondLabel={setSecondLabel}
                    showFilterBtn={showFilterBtn}
                />
            )
        );
    };

    return (
      <main id="main" className="page content deposits-page">
        {dateError && (
          <ErrorRender
            headerLabel={t("ErrorRender.dateHeaderLabel")}
            label={t("ErrorRender.dateLabel")}
            margin="15px 10px"
          />
        )}
        {!isMobile ? (
          <div>
            <div className="he-pg-ca">
              <div className="d-flex align-items-center">
                <h1>{t("deposits.title")}</h1> <h1>&nbsp;</h1>
                {currentChip === 3 && <h1>{t("deposits.beforeSep")}</h1>}
              </div>
            </div>
          </div>
        ) : null}
        {isMobile ? (
          <div style={{ padding: "0px 24px", marginTop: 0 }}>
            <h1 className="mb-3">{t("deposits.title")}</h1>
            <div className="mb-3">
              <ExpandedChip
                label={currentFirstLabel}
                setCurrentLabel={setFirstLabel}
                iconLabel={"ArrowDown"}
                labels={labeluserFunds}
                //boxRight={"initial"}
                boxWidth={"180px"}
                index={1}
                handleChipClick={handleChipClick}
                isActiveChip={isActiveChip}
                bgColor={"#FFFFFF"}
              />
            </div>
            <div className="mb-3">
              <ExpandedChip
                label={
                  currentChip === 3
                    ? t("deposits.thirdChipLabelActive")
                    : t("deposits.thirdChipLabel")
                }
                iconLabel={"arrowLeft"}
                index={3}
                handleChipClick={handleChipClick}
                bgColor={"#FFFFFF"}
              />
            </div>
            <div className="mb-3">
              <button
                className="deposits-mobile-filter-btn btn-rm-st"
                onClick={openMobileFilterPopup}
              >
                <img src={filterIcon} alt="filter" />
                <span>{t("deposits.filter")}</span>
              </button>
            </div>
            <div className="mb-3">
              <ExcelExportButton
                tableData={filteredDeposits}
                exportMainTable={currentChip === 3 ? false : true}
                disableButton={disableExportButton}
                mobileRender={true}
              />
            </div>
          </div>
        ) : null}

        <div id="deposits-wrap-details" className="deposits-wrap-details">
          {!isMobile ? (
            <div>
              <div className="d-flex align-items-center" ref={divRef}>
                <h2  className="deposits-filter-header">
                  {t("deposits.filterTitle")}
                </h2>
                <ExpandedChip
                  ariaLabel={t("general.pensionFund")}
                  label={currentFirstLabel}
                  setCurrentLabel={setFirstLabel}
                  iconLabel={"ArrowDown"}
                  labels={labeluserFunds}
                  boxRight={"7px"}
                  boxWidth={"180px"}
                  index={1}
                  handleChipClick={handleChipClick}
                  isActiveChip={isActiveChip}
                />
                {currentChip !== 3 && (
                  <ExpandedChip
                  ariaLabel={t("deposits.depositsStatus")}
                    label={currentSecondLabel}
                    setCurrentLabel={setSecondLabel}
                    iconLabel={"ArrowDown"}
                    labels={SecondChipLabels}
                    boxRight={"-55px"}
                    boxWidth={"290px"}
                    customDesign={true}
                    index={2}
                    handleChipClick={handleChipClick}
                    isActiveChip={isActiveChip}
                  />
                )}
                <ExpandedChip
                  ariaLabel={
                    currentChip === 3
                      ? t("deposits.thirdChipLabelActive")
                      : t("deposits.thirdChipLabel")
                  }
                  label={
                    currentChip === 3
                      ? t("deposits.thirdChipLabelActive")
                      : t("deposits.thirdChipLabel")
                  }
                  iconLabel={"arrowLeft"}
                  index={3}
                  handleChipClick={handleChipClick}
                  isActiveChip={isActiveChip}
                />
              </div>
              <div className="d-flex align-items-center deposits-second-line-wrapper">
                <div className="form-item">
                  <RadioButtons
                    setRadioValue={setRadioValue}
                    radioValue={radioValue}
                    firstRadioTString="LettersReports.radioValue1"
                    secondRadioTString="LettersReports.radioValue2"
                  />
                  <HeDatePicker
                    dateLabel={t("general.fromDate")}
                    dateValue={startDateValue}
                    setDateValue={setStartDateValue}
                    isDisabled={datePickerIsDisabled}
                    isOpenFun={()=>{}}
                  />
                  <HeDatePicker
                    dateLabel={t("general.toDate")}
                    dateValue={endDateValue}
                    setDateValue={setEndDateValue}
                    isDisabled={datePickerIsDisabled}
                    isOpenFun={()=>{}}
                  />
                </div>
                <ExcelExportButton
                  tableData={filteredDeposits}
                  exportMainTable={currentChip === 3 ? false : true}
                  disableButton={disableExportButton}
                />
              </div>
            </div>
          ) : null}
          {loading ? (
            <CircleLoading />
          ) : (
            <>
              {!(filteredDeposits && filteredDeposits?.length) ? (
                <DetailsNotFound
                  setRadioValue={setRadioValue}
                  setStartDate={setStartDateValue}
                  setEndDate={setEndDateValue}
                  latestFirstLabel={latestFirstLabel}
                  setFirstLabel={setFirstLabel}
                  latestSecondLabel={latestSecondLabel}
                  setSecondLabel={setSecondLabel}
                  latestChip={latestChip}
                  setCurrentChip={setCurrentChip}
                  latestRenderLabel={latestRenderLabel}
                  setRenderLabel={setRenderLabel}
                />
              ) : currentChip === 3 ? (
                <SepTable tableData={filteredDeposits} />
              ) : (
                <>
                  {!isMobile ? (
                    <TableExpanded
                      tableData={filteredDeposits}
                      mobileRender={false}
                      funds={funds}
                    />
                  ) : (
                    <TableExpanded
                      funds={funds}
                      tableData={filteredDeposits}
                      mobileRender={true}
                    />
                  )}
                </>
              )}
            </>
          )}
        </div>
      </main>
    );
};

export default Deposits;
